var React = require('react');

function Iphone (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"3","fill":"none"},[React.createElement("rect",{"x":"2","y":"2","width":"44.65","height":"84.95","rx":"4.51","key":0}),React.createElement("line",{"x1":"2.05","y1":"11.67","x2":"46.6","y2":"11.67","key":1}),React.createElement("line",{"x1":"2.05","y1":"68.98","x2":"46.6","y2":"68.98","key":2}),React.createElement("circle",{"cx":"24.33","cy":"77.88","r":"3.15","key":3})]));
}

Iphone.defaultProps = {"className":"svg-iphone","viewBox":"0 0 48.65 88.95","stroke":"#000000"};

module.exports = Iphone;

Iphone.default = Iphone;
